TaskCommentsDirective.$inject = [];
export default function TaskCommentsDirective() {
    return {
        restrict: 'AE',
        scope: {
            'taskId': '=',
            'canAddCommentsTask': '=',
        },
        template: require('./task-comments.html'),
        controller: 'TaskCommentsCtrl',
        controllerAs: 'vm',
        bindToController: true
    }
}